export default "__VITE_ASSET__564fe945__"